//引入vue
import Vue from "vue";
import util from "./util";
//必须实例化
const vm = new Vue()


export default {
    install(Vue) {
        Vue.prototype.insuranceCompanyCheck = function (dataForm) {
            return new Checker().check(dataForm);
        }
    }
}


/**
 * 保单分期保险公司校验使用
 */
class Checker {
    //指定对象，指定属性，空校验。
    specifyObjectAttributeNullCheck(object, attribute, errorMessage) {
        if (object[attribute] === "" || object[attribute] == null) {
            this.showMessage(errorMessage, "error");
            return false;
        }

        return true;
    }

    //解决弹窗重叠
    showMessage(message, type) {
        setTimeout(() => {
            vm["$message"]({
                type,
                message,
            });
        }, 0);
    }

    //保险公司基本属性校验
    insuranceCompanyListNullCheck(object) {
        let result = true;
        //保险公司空校验
        result &= this.specifyObjectAttributeNullCheck(object, "insuranceCompany", "保险公司不能为空");
        if (!result) return false;//没有公司名，后续提示弹窗会无法正确显示，所以直接取消后续校验。

        //承保比例空校验
        result &= this.specifyObjectAttributeNullCheck(object, "underwriteRate", "承保比例不能为空");
        //保险公司保费空校验
        result &= this.specifyObjectAttributeNullCheck(object, "premium", "保险公司保费不能为空");
        //佣金比例空校验
        result &= this.specifyObjectAttributeNullCheck(object, "yongjinRate", "佣金比例不能为空");

        return result;
    }

    //保险公司详情属性校验
    insuranceCompanyPremiumDetailListNullCheck(object, companyName) {
        let result = true;
        //保费支付情况空校验
        result &= this.specifyObjectAttributeNullCheck(object, "paymentState", companyName + "的保费支付情况不能为空");
        //保费开票状况情况空校验
        result &= this.specifyObjectAttributeNullCheck(object, "billingState", companyName + "的保费开票状况不能为空");
        //分期支付日期空校验
        result &= this.specifyObjectAttributeNullCheck(object, "premiumDueDate", companyName + "的分期支付日期不能为空");
        //分期支付金额空校验
        result &= this.specifyObjectAttributeNullCheck(object, "paymentBal", companyName + "的分期支付金额不能为空");

        return result;
    }


    async confirmWait(message) {
        return vm["$confirm"](message, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            distinguishCancelAndClose: true,    // 重要，设置为true才会把右上角X和取消区分开来
            closeOnClickModal: false
        }).then(function () {
            return true;
        }).catch(function (e) {
            if (e === "cancel" || e === "close") {
                return false;
            }
        });
    }

    /**
     * 校验
     * @param dataForm
     * @returns {Promise<boolean | boolean>}
     */
    check(dataForm) {
        let companyList = dataForm.insuranceCompanyList;

        //起保日期早于当前系统时间，需要操作人确认是否继续
        let startDateCheck = new Promise((resolve, reject) => {
            resolve(dataForm);
        });

        return startDateCheck.then(res => {
            let startDate = new Date(dataForm.startDate);
            let sysDate = new Date();
            if (startDate < sysDate && startDate.getDate() !== sysDate.getDate()) {
                return vm["$confirm"]("【起保日期】早于【当前日期】是否继续？", "提示", {
                    confirmButtonText: "继续",
                    cancelButtonText: "返回",
                    type: "warning",
                    distinguishCancelAndClose: true,    // 重要，设置为true才会把右上角X和取消区分开来
                    closeOnClickModal: false
                }).then(function () {
                    return true;
                }).catch(function (e) {
                    if (e === "cancel" || e === "close") {
                        return Promise.reject();
                    }
                });
            }
        }).then(() => {
            let totalPremiumSum = 0, underwriteRateSUm = 0, selectedCompanyNameHash = {};
            for (let i = 0; i < companyList.length; i++) {
                let companyElement = companyList[i];
                //保险公司基本属性校验
                if (!this.insuranceCompanyListNullCheck(companyElement)) return Promise.reject();

                //判断HASH是否已经存在该保险公司
                if (selectedCompanyNameHash[companyElement.insuranceCompany] === companyElement.insuranceCompany) {
                    this.showMessage("【" + companyElement.insuranceCompany + "】保险公司存在重复，请重新选择", "error");
                    return Promise.reject();
                }
                //记录公司名
                selectedCompanyNameHash[companyElement.insuranceCompany] = companyElement.insuranceCompany;

                //每个公司分期保费总和
                let paymentBalSum = 0, premiumDetailList = companyElement.premiumDetailList;
                for (let j = 0; j < premiumDetailList.length; j++) {
                    let premiumDetailEle = premiumDetailList[j];
                    //保险公司详情属性校验
                    if (!this.insuranceCompanyPremiumDetailListNullCheck(premiumDetailEle, companyElement.insuranceCompany)) return Promise.reject();

                    //分期保费求和
                    let t = util.Delcommafy(premiumDetailEle.paymentBal);
                    t *= 100;
                    paymentBalSum += t;
                }

                //分期保费和公司保费校验
                paymentBalSum = paymentBalSum / 100;
                paymentBalSum = paymentBalSum.toFixed(2);

                if (util.Delcommafy(companyElement.premium) - paymentBalSum !== 0) {
                    this.showMessage(companyElement.insuranceCompany + "的分期保费之和不等于总计保费", "error");
                    return Promise.reject();
                }

                //承保比例和总保费求和
                //精度问题处理 1-先乘100
                totalPremiumSum += util.Delcommafy(companyElement.premium) * 100;
                let num = companyElement.underwriteRate.replace(/%/g, ""); //获取去除了百分号的数字字符串
                underwriteRateSUm += Number(num);
            }

            //承保比例和总保费校验
            //精度问题处理 2-再除100
            totalPremiumSum = totalPremiumSum / 100;
            totalPremiumSum = totalPremiumSum.toFixed(2);

            //因为出单发起的新增保单会跳过保费联动。所以此处必须以等于0来判断
            if (util.Delcommafy(dataForm.totalPremium) - totalPremiumSum !== 0) {
                this.showMessage("公司的保费之和不等于总保费", "error");
                return Promise.reject();
            }

            if (underwriteRateSUm / 100 - 1 !== 0) {
                this.showMessage("承保比例之和需要等于100%", "error");
                return Promise.reject();
            }
        }).then(() => {
            //校验，当保费支付情况”→“已支付”，则必须填写实际支付日期才能进行下一步
            for (let i = 0; i < companyList.length; i++) {
                for (let j= 0; j < companyList[i].premiumDetailList.length; j++) {
                    let premiumDetailEle = companyList[i].premiumDetailList[j];
                    if (premiumDetailEle.paymentState === "1" && (premiumDetailEle.actualPaymentDate === "" || premiumDetailEle.actualPaymentDate == null)) {
                        this.showMessage(companyList[i].insuranceCompany + "，保费支付情况为【已支付】，需填写对应【保费实收日期】", "error");
                        return Promise.reject();
                    }
                }
            }
        }).then(() => {
            //校验保险公司的分期日期符合规则，是否需要弹窗确认
            let ifConfirm = false;
            for (let i = 0; i < companyList.length; i++) {
                let companyElement = companyList[i];
                let premiumDetailList = companyElement.premiumDetailList;

                for (let j = 0; j < premiumDetailList.length; j++) {
                    let premiumDetailEle = premiumDetailList[j];
                    //分期支付日期必须在范围内[起保日期，终止日期],且分期支付日期必须是递增的
                    let start = new Date(dataForm.startDate);
                    let end = new Date(dataForm.endDate);
                    let cur = new Date(premiumDetailEle.premiumDueDate);

                    if (j !== 0) {//非第一个分期支付日期，则start日期为前一个分期支付日期。
                        start = new Date(premiumDetailList[j - 1].premiumDueDate);
                    }

                    //超出日期范围，提示并p判断是否退出校验
                    if (cur < start || cur > end) {
                        //出现这种，表示需要弹询问是否继续。
                        ifConfirm = true;
                    }
                }
            }

            if (ifConfirm) {
                return this.confirmWait("存在保险公司【分期支付日期】不符合【分期支付日期】必须在保单【起保日期】和【终止日期】之间，且每期递增的规则！是否继续？");
            } else {
                return true;
            }
        }).catch(error => {
            return Promise.resolve(false);
        });
    }
}



// WEBPACK FOOTER //
// ./src/common/js/common.js